import { useState } from 'react'
import { cn } from '~/@/lib/utils'
import {
  PromptInput,
  PromptInputBody,
  PromptInputSubmit,
  PromptInputTextarea,
} from '~/components/ai-elements/prompt-input'
import { useCreateNewDossbotChat } from '~/components/dossbot/useCreateDossbotChat'
import { resizeTextarea, useTextareaResize } from '~/components/dossbot/useTextareaResize'

interface DossbotNewChatProps {
  onCreateChat: (chatId: string) => void
  inputClassName?: string
}

/**
 * DossbotNewChat component that allows the user to create a new chat
 */
export const DossbotNewChat = ({ onCreateChat, inputClassName }: DossbotNewChatProps) => {
  const { createChat } = useCreateNewDossbotChat()
  const [input, setInput] = useState('')
  const textareaRef = useTextareaResize(input)

  const handleSubmit = async (prompt: string) => {
    const chatId = await createChat(prompt)
    if (chatId) {
      onCreateChat(chatId)
    }
    setInput('')
  }

  return (
    <div className="flex h-full flex-col">
      <div className="flex-1" />
      <PromptInput
        className="relative items-end justify-end pt-4"
        onSubmit={(prompt) => {
          if (!prompt.text) {
            return
          }
          handleSubmit(prompt.text)
        }}
      >
        <PromptInputBody
          className={cn(
            'mx-4 mb-4 flex flex-row items-end justify-between rounded-lg border border-gray-4 bg-white px-4 py-3 dark:border-gray-6 dark:bg-gray-8',
            inputClassName,
          )}
        >
          <PromptInputTextarea
            ref={textareaRef}
            onChange={(e) => {
              setInput(e.target.value)
              resizeTextarea(e.target)
            }}
            placeholder="Enter message"
            value={input}
          />
          <PromptInputSubmit disabled={!input} status={'ready'} />
        </PromptInputBody>
      </PromptInput>
    </div>
  )
}
